// ============================================================
// xFreeScan by XCloud Solutions - App Router
// ============================================================
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import ExecutiveDashboard from './pages/dashboard/ExecutiveDashboard';
import NewScanPage from './pages/scans/NewScanPage';
import ScanListPage from './pages/scans/ScanListPage';
import ScanDetailPage from './pages/scans/ScanDetailPage';
import ReportPage from './pages/reports/ReportPage';
import AlertsPage from './pages/alerts/AlertsPage';
import PricingPage from './pages/PricingPage';
import DashboardLayout from './components/layout/DashboardLayout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-purple-600 border-t-transparent" />
          <p className="text-gray-500">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="scans" element={<ScanListPage />} />
        <Route path="scans/new" element={<NewScanPage />} />
        <Route path="scans/:id" element={<ScanDetailPage />} />
        <Route path="reports/:scanId" element={<ReportPage />} />
        <Route path="executive" element={<ExecutiveDashboard />} />
        <Route path="alerts" element={<AlertsPage />} />
        <Route path="pricing" element={<PricingPage />} />
      </Route>

      {/* Pricing also accessible without auth */}
      <Route path="/pricing" element={
        <ProtectedRoute><DashboardLayout /></ProtectedRoute>
      }>
        <Route index element={<PricingPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
